import React from 'react'
import { TABLE_LIST_MASTER_DATA } from '../../../constants/tableListMasterData'
import ManageMasterData from './ManageMasterData'

//#region  จัดการคำนำหน้าชื่อ
export function ManageMasterDataPreName() {
  return (
    <ManageMasterData
      title={TABLE_LIST_MASTER_DATA.PRENAME.NAME_LABEL}
      table={TABLE_LIST_MASTER_DATA.PRENAME.TABLE}
    />
  )
}
//#endregion จัดการคำนำหน้าชื่อ

//#region จัดการพื้นที่ดำเนินการ
export function ManageMasterDataSetting() {
  return (
    <ManageMasterData
      title={TABLE_LIST_MASTER_DATA.SETTING.NAME_LABEL}
      table={TABLE_LIST_MASTER_DATA.SETTING.TABLE}
    />
  )
}
//#endregion จัดการพื้นที่ดำเนินการ

//#region กลุ่มเป้าหมายดำเนินการ
export function ManageMasterDataTarget() {
  return (
    <ManageMasterData
      title={TABLE_LIST_MASTER_DATA.TARGET.NAME_LABEL}
      table={TABLE_LIST_MASTER_DATA.TARGET.TABLE}
    />
  )
}
//#endregion กลุ่มเป้าหมายดำเนินการ

//#endregion ประเด็น
export function ManageMasterDataIssue() {
  return (
    <ManageMasterData
      title={TABLE_LIST_MASTER_DATA.ISSUE.NAME_LABEL}
      table={TABLE_LIST_MASTER_DATA.ISSUE.TABLE}
    />
  )
}
//#region ประเด็น

//#region ประเภทคดี
export function ManageMasterDataLawType() {
  return (
    <ManageMasterData
      title={TABLE_LIST_MASTER_DATA.LAW_TYPE.NAME_LABEL}
      table={TABLE_LIST_MASTER_DATA.LAW_TYPE.TABLE}
    />
  )
}
//#endregion ประเภทคดี

//#region สถานะทางกฎหมาย
export function ManageMasterDataLawStatus() {
  return (
    <ManageMasterData
      title={TABLE_LIST_MASTER_DATA.LAW_STATUS.NAME_LABEL}
      table={TABLE_LIST_MASTER_DATA.LAW_STATUS.TABLE}
    />
  )
}
//#endregion สถานะทางกฎหมาย

//#region ประเภทพื้นที่ดำเนินการ
export function ManageMasterDataLocationType() {
  return (
    <ManageMasterData
      title={TABLE_LIST_MASTER_DATA.LOCATION_TYPE.NAME_LABEL}
      table={TABLE_LIST_MASTER_DATA.LOCATION_TYPE.TABLE}
    />
  )
}
//#endregion ประเภทพื้นที่ดำเนินการ

//#region แผนงาน
export function ManageMasterDataThaihealthPlan() {
  return (
    <ManageMasterData
      title={TABLE_LIST_MASTER_DATA.STRATEGY_OF_THAIHEALTH_PLAN.NAME_LABEL}
      table={TABLE_LIST_MASTER_DATA.STRATEGY_OF_THAIHEALTH_PLAN.TABLE}
    />
  )
}
//#endregion แผนงาน
